// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessChainSchema, ProcessSwimlaneMappingSchema } from '../../entities/process-chain/process-chain.schema';
import { ProcessCategorySchema } from '../../entities/process/process.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * Populated process data within a chain mapping
 * Extends ProcessSwimlaneMappingSchema with populated fields from Process entity
 */ export const PopulatedChainProcessSchema = ProcessSwimlaneMappingSchema.extend({
    processName: z.string(),
    processCategory: ProcessCategorySchema.nullable().optional(),
    departmentName: z.string().optional()
});
/**
 * Get Process Chain Response Schema
 * GET /api/v2/process-chains/:id
 * Returns chain with populated process data
 */ export const GetProcessChainResponseSchema = z.object({
    processChain: ProcessChainSchema.extend({
        populatedProcesses: z.array(PopulatedChainProcessSchema),
        childCount: z.number().int()
    })
});
export const GetProcessChainErrorSchema = BaseErrorSchema;

//# sourceMappingURL=get-process-chain.schema.js.map